import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort--sprite",
  "use": "sort--sprite-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sort--sprite\">\n<path d=\"M2.74659 8.33333H7.25325L4.99992 10.5867L2.74659 8.33333ZM0.333252 7.33333L4.99992 12L9.66659 7.33333L0.333252 7.33333ZM0.333252 4.66667L9.66659 4.66667L4.99992 0L0.333252 4.66667Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol